module.exports = __webpack_public_path__ + "static/media/huiyuan.c5c6f3b8.png";